import {
  SharedModule,
  CustomDetailComponent,
  DataService,
  NotificationService,
  ModalService,
} from "@bb-vendure/admin-ui/core";
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import {
  FormGroup,
  UntypedFormGroup,
  FormArray,
  FormBuilder,
} from "@angular/forms";
import { Observable, take, Subject, takeUntil, combineLatest, merge } from "rxjs";
import {
  CreateFreeGiftConditionDocument,
  FetchVariantGiftListDocument,
  FreeGiftSelectionFromProductIdDocument,
  GetProductSupplierDocument,
  UpsertVariantFreeGiftSelectionDocument,
} from "src/generated-gql/graphql";
import ConditionCardComponent from "../condition-card/condition-card.component";
import AddContidionDialogComponent from "../FreeGiftsNg/Add-Condition/add-condition.component";

@Component({
  imports: [SharedModule, ConditionCardComponent],
  standalone: true,
  templateUrl: "./variant-free-gift-list.component.html",
  styleUrl: "./variant-free-gift-list.component.scss",
})
export default class VariantFreeGiftListComponent
  implements CustomDetailComponent, OnInit
{
  entity$: Observable<any>;
  detailForm: UntypedFormGroup;
  productId: string = "";
  productName: string = "";

  freeGifts = false;

  //selections: any[] = [];

  isNew = true;
  constructor(
    protected dataService: DataService,
    private notificationService: NotificationService,
    private modalService: ModalService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
  }

  variantSelectionFormArray: FormArray = this.formBuilder.array([]);

  productSelectionForm: FormGroup = this.formBuilder.group({
    id: [""],
    name: [""],
    title: [""],
    isRandom: [false],
    conditions: [[]],
  });

  ngOnInit(): void {
    this.entity$.subscribe((entity) => {
      this.isNew = false;
      this.productId = entity.id;
      this.productName = entity.name;
      this.freeGifts = entity.customFields.freeGifts;
      this.productSelectionForm.patchValue({
        id: `product-${this.productId}`,
        name: entity.name,
      })
      this.refresh(entity.id);
      // this.getSelectionProduct(entity.id);
    });

    this.detailForm.get("customFields.randomOption")?.valueChanges.subscribe((value) => {
      if(value == true) {
        const giftByVariant = this.detailForm.get("customFields.giftByVariant")?.value 
        if(giftByVariant == true) {
          this.notificationService.error("Random Option can only be used with Product Level Free Gift");
          this.detailForm.get("customFields.randomOption")?.setValue(false);
        }
      }
    })
    this.detailForm.get("customFields.giftByVariant")?.valueChanges.subscribe((value) => {
      if(value == true) {
        const randomOption = this.detailForm.get("customFields.randomOption")?.value 
        if(randomOption == true) {
          this.notificationService.error("Variant Level Free Gift can only be used with non-random option");
          this.detailForm.get("customFields.giftByVariant")?.setValue(false);
        }
      }
    })
  }

  getSelectionProduct(productId: string) {
    return this.dataService.query(FreeGiftSelectionFromProductIdDocument, {
      id: productId
    }).single$.pipe(take(1)).subscribe(({ freeGiftSelectionFromProductId }) => {
      if (freeGiftSelectionFromProductId) {
        this.productSelectionForm.patchValue({
          id: freeGiftSelectionFromProductId.id,
          title: freeGiftSelectionFromProductId.title,
          isRandom: freeGiftSelectionFromProductId.isRandom,
          conditions: freeGiftSelectionFromProductId.conditions,
        })
        this.cdr.markForCheck();
      }
    })
  }

  getSelectionVariant(productId: string) {
    this.dataService
      .query(FetchVariantGiftListDocument, {
        id: productId,
      })
      .single$.pipe(take(1))
      .subscribe((res) => {
        this.variantSelectionFormArray.clear();

        for (const s of res.variantFreeGiftSelectionsFromProductId ?? []) {
          const selectionForm = this.formBuilder.group({
            id: s.id,
            name: s.productVariant!.name,
            title: [s.title ?? ""],
            isRandom: [s.isRandom ?? false],
            conditions: [[...(s.conditions ?? [])]],
          });
          this.variantSelectionFormArray.push(selectionForm);
        }
        this.cdr.markForCheck();
      });
  }

  refresh(productId: string) {
    this.getSelectionVariant(productId);
    this.getSelectionProduct(productId);
  }

  getConditions(form: FormGroup) {
    //console.log({ form });

    return form.value.conditions ?? [];
  }

  saveSelection(selectionForm: FormGroup) {
    const data = selectionForm.value;

    // if (data.isRandom) {
    //   const conditions = data.conditions;

    //   if (conditions.length > 1) {
    //     this.notificationService.error(
    //       "Random free gift can only have one condition"
    //     );
    //     return;
    //   }
    // }

    this.dataService
      .mutate(UpsertVariantFreeGiftSelectionDocument, {
        input: {
          id: data.id,
          title: data.title,
          isRandom: data.isRandom,
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.notificationService.success("Update free gift successfully");
          selectionForm.markAsPristine();
          this.cdr.markForCheck();
          //this.refresh(this.productId)
        }
      });
  }

  fetchRetailerAndArtist(
    callback: ({
      retailer,
      artist,
    }: {
      retailer: string;
      artist: string;
    }) => void
  ) {
    this.dataService
      .query(GetProductSupplierDocument, { id: this.productId })
      .single$.pipe(take(1))
      .subscribe((res) => {
        if (!res.product) return;

        const retailer = res.product.customFields?.retailer;
        if (!retailer) {
          this.notificationService.error(
            "Retailer not found, Please add retailer to product"
          );
          return;
        }

        const artist = res.product.customFields?.artist;
        if (!artist) {
          this.notificationService.error(
            "Artist not found, Please add artist to product"
          );
          return;
        }

        callback({ retailer: retailer.id, artist: artist.id });
      });
  }

  addCondition(selectionId: string) {
    this.fetchRetailerAndArtist(({ retailer, artist }) => {
      this.modalService
        .fromComponent(AddContidionDialogComponent, {
          size: "lg",
          closable: true,
          locals: {
            condition: null,
            productRetailer: retailer,
            productArtist: artist,
            productName: this.productName,
            detailForm: this.detailForm,
          },
        })
        .pipe(take(1))
        .subscribe((result) => {
          if (!result.productVariants.length) {
            this.notificationService.error("Must select variants");
            return;
          }
          this.dataService
            .mutate(CreateFreeGiftConditionDocument, {
              input: {
                selectionId: selectionId,
                giftQuantity: result.giftQuantity,
                minQuantity: result.minQuantity,
                productVariantIds: result.productVariants,
              },
            })
            .pipe(take(1))
            .subscribe((res) => {
              if (
                res.createFreeGiftCondition.__typename === "FreeGiftCondition"
              ) {
                this.notificationService.success(
                  "Condition Added Successfully"
                );
                this.refresh(this.productId);
              }
            });
        });
    });
  }

  addConditionProduct(selectionId: string) {
    this.fetchRetailerAndArtist(({ retailer, artist }) => {
      this.modalService
        .fromComponent(AddContidionDialogComponent, {
          size: "lg",
          closable: true,
          locals: {
            condition: null,
            productRetailer: retailer,
            productArtist: artist,
            productName: this.productName,
            detailForm: this.detailForm
          },
        })
        .pipe(take(1))
        .subscribe((result) => {
          if (!result.productVariants.length) {
            this.notificationService.error("Must select variants");
            return;
          }
          this.dataService
            .mutate(CreateFreeGiftConditionDocument, {
              input: {
                selectionId: selectionId,
                giftQuantity: result.giftQuantity,
                minQuantity: result.minQuantity,
                productVariantIds: result.productVariants,
                // productId: this.productId
              },
            })
            .pipe(take(1))
            .subscribe((res) => {
              if (
                res.createFreeGiftCondition.__typename === "FreeGiftCondition"
              ) {
                this.notificationService.success(
                  "Condition Added Successfully"
                );
                this.refresh(this.productId);
              }
            });
        });
    });
  }
}
